import React from 'react';

import { useTitle } from '@admin/hooks/use_title';
import { RateAdjustment__Upload__Product } from '@admin/schema';

import { RateAdjustmentUploaderForm } from './form';

export const SelfStorageRateAdjustmentUploaderForm: React.FC = () => {
  useTitle('Self-Storage Rate Adjustments');
  return <RateAdjustmentUploaderForm listOnly product={RateAdjustment__Upload__Product.SelfStorage} />;
};
